<template>
  <a
    :aria-label="cookieButtonWrongLabel"
    :style="formStyles"
    @click.prevent="resetCookie()">
    {{ cookieButtonWrongLabel }}
  </a>
</template>
<script>
export default {
  name: "CookieReset",
  props: {
    cookieButtonWrongLabel: {
      type: String,
      required: true
    },
    formStyles: {
      type: Object,
      default: () => {}
    },
    trackedAdvocateShortUrlParam: {
      type: String,
      default: ""
    }
  },
  computed: {
    resetParams() {
      return {
        trackedAdvocateShortUrlParam: this.trackedAdvocateShortUrlParam
      };
    }
  },
  methods: {
    resetCookie() {
      this.redirectHelper.redirectToResetCookie(this.resetParams);
    }
  },
  inject: {
    redirectHelper: { from: "redirectHelper" }
  }
};
</script>
